export default __webpack_public_path__ + "static/media/loading.a9ea33b4.gif";